import PropTypes from "prop-types";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import { useCallback, useEffect } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { logout as logoutAction } from "app/pages/Auth/AuthActions";
import { fetchCoupons as fetchCouponsAction } from "app/pages/Account/MyCoupons/couponActionCreators";
import {
	getAvailableCreditNotesTotal,
	getAvailableCreditsTotal,
	hasAnyCreditNotes,
} from "app/pages/Account/MyCoupons/couponSelector";
import { useMyBookingsCustomerRequestsCount } from "app/features/myBookings";
import { isAuthenticated } from "app/pages/Auth/authSelectors";
import { brandPropTypes } from "app/utils/propTypes";
import AccountAsideMenuAuthenticated from "app/pages/Account/AccountAsideMenu/AccountAsideMenuAuthenticated";

const mapStateToProps = state => {
	return {
		userIsConnected: isAuthenticated(state),
		brand: state.brand.code,
		enableSponsorship: state.partner.enableSponsorship,
		enableCredits: state.partner.enableCredits,
		enableCreditNotes: state.partner.enableCreditNotes,
		partnerCode: state.partner.code,
		totalCredit: getAvailableCreditsTotal(state),
		totalCreditNote: getAvailableCreditNotesTotal(state),
		shouldDisplayCreditNotesEntry: hasAnyCreditNotes(state),
	};
};

const AccountAsideMenuAuthenticatedContainer = () => {
	const {
		brand,
		enableSponsorship = false,
		enableCredits = false,
		enableCreditNotes = false,
		partnerCode,
		totalCredit,
		totalCreditNote,
		shouldDisplayCreditNotesEntry = false,
		userIsConnected = false,
	} = useSelector(mapStateToProps, shallowEqual);

	const myBookingsCustomerRequestCount = useMyBookingsCustomerRequestsCount();

	const dispatch = useDispatch();
	const { track } = useAnalytics();
	const logout = useCallback(() => dispatch(logoutAction({ track })), [dispatch, track]);
	const fetchCoupons = useCallback(() => dispatch(fetchCouponsAction()), [dispatch]);

	useEffect(() => {
		if (enableCredits || enableCreditNotes) {
			fetchCoupons();
		}
	}, [enableCredits, enableCreditNotes]);

	return (
		<AccountAsideMenuAuthenticated
			enableSponsorship={enableSponsorship}
			enableCredits={enableCredits}
			brand={brand}
			partnerCode={partnerCode}
			creditsAmount={totalCredit}
			creditNotesAmount={totalCreditNote}
			shouldDisplayCreditNotesEntry={shouldDisplayCreditNotesEntry}
			showCustomerRequestNotification={myBookingsCustomerRequestCount > 0}
			userIsConnected={userIsConnected}
			logout={logout}
		/>
	);
};

AccountAsideMenuAuthenticatedContainer.propTypes = {
	enableCredits: PropTypes.bool,
	enableCreditNotes: PropTypes.bool,
	enableSponsorship: PropTypes.bool,
	userIsConnected: PropTypes.bool,
	fetchCoupons: PropTypes.func,
	logout: PropTypes.func,
	brand: brandPropTypes,
	shouldDisplayCreditNotesEntry: PropTypes.bool,
	partnerCode: PropTypes.string,
	totalCredit: PropTypes.number,
	totalCreditNote: PropTypes.number,
};

export default AccountAsideMenuAuthenticatedContainer;
